export default __webpack_public_path__ + "static/media/miniBannerThree.beb0653d.jpeg";